<template>
  <div class="flex justify-center">
    <div style="max-width: 314px">
      <div>
        <div class="text-center"><h3>Logged out</h3></div>
        <div>
          <router-link to="signIn">Sign in</router-link>
        </div>
        <div>
          <router-link to="signup">Sign up</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'SignOut',
    components: {},
    data: () => ({}),
    watch: {},
    async mounted() {
      this.$store.dispatch('signOut')
      this.$router.push({ name: 'signIn' })
    }
  }
</script>

<style scoped></style>
